export default [
    {
        path: '/addresses',
        name: 'addresses',
        component: () => import(/* webpackChunkName: "addresses" */ './components/TableViewBase.vue'),
        staticProps: { tablePromise: () => import(/* webpackChunkName: "addresses" */ './tables/AddressesTable.vue'), pageTitle: 'Addresses' }
    },
    {
        path: '/address/:id',
        name: 'address',
        component: () => import(/* webpackChunkName: "address" */ './editViews/Address.vue')
    },
    {
        path: '/affliction-tests',
        name: 'afflictionTests',
        component: () => import(/* webpackChunkName: "affliction-tests" */ './components/TableViewBase.vue'),
        staticProps: { tablePromise: () => import(/* webpackChunkName: "affliction-tests" */ './tables/AfflictionTestsTable.vue'), pageTitle: 'Affliction Tests' }
    },
    {
        path: '/audits',
        name: 'audits',
        component: () => import(/* webpackChunkName: "audits" */ './components/TableViewBase.vue'),
        staticProps: { tablePromise: () => import(/* webpackChunkName: "audits" */ './tables/AuditsTable.vue'), pageTitle: 'Audits' }
    },
    {
        path: '/auditors',
        name: 'auditors',
        component: () => import(/* webpackChunkName: "auditors" */ './components/TableViewBase.vue'),
        staticProps: { tablePromise: () => import(/* webpackChunkName: "auditors" */ './tables/AuditorsTable.vue'), pageTitle: 'Auditors' }
    },
    {
        path: '/auditor/:id',
        name: 'auditor',
        component: () => import(/* webpackChunkName: "auditor" */ './editViews/Auditor.vue')
    },
    {
        path: '/auditor-members',
        name: 'auditorMembers',
        component: () => import(/* webpackChunkName: "auditor-members" */ './components/TableViewBase.vue'),
        staticProps: { tablePromise: () => import(/* webpackChunkName: "auditor-members" */ './tables/AuditorMembersTable.vue'), pageTitle: 'Auditor Members' }
    },
    {
        path: '/biosecurity-incident-files',
        name: 'biosecurityIncidentFiles',
        component: () => import(/* webpackChunkName: "biosecurity-incident-files" */ './components/TableViewBase.vue'),
        staticProps: { tablePromise: () => import(/* webpackChunkName: "biosecurity-incident-files" */ './tables/BiosecurityIncidentFilesTable.vue'), pageTitle: 'Biosecurity Incident Files' }
    },
    {
        path: '/blends',
        name: 'blends',
        component: () => import(/* webpackChunkName: "blends" */ './components/TableViewBase.vue'),
        staticProps: { tablePromise: () => import(/* webpackChunkName: "blends" */ './tables/BlendsTable.vue'), pageTitle: 'Blends' }
    },
    {
        path: '/blend/:id',
        name: 'blend',
        component: () => import(/* webpackChunkName: "blend" */ './editViews/Blend.vue')
    },
    {
        path: '/blend-components',
        name: 'blendComponents',
        component: () => import(/* webpackChunkName: "blend-components" */ './components/TableViewBase.vue'),
        staticProps: { tablePromise: () => import(/* webpackChunkName: "blend-components" */ './tables/BlendComponentsTable.vue'), pageTitle: 'Blend Components' }
    },
    {
        path: '/blend-honey-types',
        name: 'blendHoneyTypes',
        component: () => import(/* webpackChunkName: "blend-honey-types" */ './components/TableViewBase.vue'),
        staticProps: { tablePromise: () => import(/* webpackChunkName: "blend-honey-types" */ './tables/BlendHoneyTypesTable.vue'), pageTitle: 'Blend Honey Types' }
    },
    {
        path: '/blend-receivals',
        name: 'blendReceivals',
        component: () => import(/* webpackChunkName: "blend-receivals" */ './components/TableViewBase.vue'),
        staticProps: { tablePromise: () => import(/* webpackChunkName: "blend-receivals" */ './tables/BlendReceivalsTable.vue'), pageTitle: 'Blend Receivals' }
    },
    {
        path: '/blend-suppliers',
        name: 'blendSuppliers',
        component: () => import(/* webpackChunkName: "blend-suppliers" */ './components/TableViewBase.vue'),
        staticProps: { tablePromise: () => import(/* webpackChunkName: "blend-suppliers" */ './tables/BlendSuppliersTable.vue'), pageTitle: 'Blend Suppliers' }
    },
    {
        path: '/blend-supplier/:id',
        name: 'blendSupplier',
        component: () => import(/* webpackChunkName: "blend-supplier" */ './editViews/BlendSupplier.vue')
    },
    {
        path: '/calibrations',
        name: 'calibrations',
        component: () => import(/* webpackChunkName: "calibrations" */ './components/TableViewBase.vue'),
        staticProps: { tablePromise: () => import(/* webpackChunkName: "calibrations" */ './tables/CalibrationsTable.vue'), pageTitle: 'Calibrations' }
    },
    {
        path: '/chemicals',
        name: 'chemicals',
        component: () => import(/* webpackChunkName: "chemicals" */ './components/TableViewBase.vue'),
        staticProps: { tablePromise: () => import(/* webpackChunkName: "chemicals" */ './tables/ChemicalsTable.vue'), pageTitle: 'Chemicals' }
    },
    {
        path: '/chemical/:id',
        name: 'chemical',
        component: () => import(/* webpackChunkName: "chemical" */ './editViews/Chemical.vue')
    },
    {
        path: '/chemical-purchases',
        name: 'chemicalPurchases',
        component: () => import(/* webpackChunkName: "chemical-purchases" */ './components/TableViewBase.vue'),
        staticProps: { tablePromise: () => import(/* webpackChunkName: "chemical-purchases" */ './tables/ChemicalPurchasesTable.vue'), pageTitle: 'Chemical Purchases' }
    },
    {
        path: '/chemical-purchase/:id',
        name: 'chemicalPurchase',
        component: () => import(/* webpackChunkName: "chemical-purchase" */ './editViews/ChemicalPurchase.vue')
    },
    {
        path: '/claims',
        name: 'claims',
        component: () => import(/* webpackChunkName: "claims" */ './components/TableViewBase.vue'),
        staticProps: { tablePromise: () => import(/* webpackChunkName: "claims" */ './tables/ClaimsTable.vue'), pageTitle: 'Claims' }
    },
    {
        path: '/claim/:id',
        name: 'claim',
        component: () => import(/* webpackChunkName: "claim" */ './editViews/Claim.vue')
    },
    {
        path: '/cleanings',
        name: 'cleanings',
        component: () => import(/* webpackChunkName: "cleanings" */ './components/TableViewBase.vue'),
        staticProps: { tablePromise: () => import(/* webpackChunkName: "cleanings" */ './tables/CleaningsTable.vue'), pageTitle: 'Cleanings' }
    },
    {
        path: '/contacts',
        name: 'contacts',
        component: () => import(/* webpackChunkName: "contacts" */ './components/TableViewBase.vue'),
        staticProps: { tablePromise: () => import(/* webpackChunkName: "contacts" */ './tables/ContactsTable.vue'), pageTitle: 'Contacts' }
    },
    {
        path: '/contact/:id',
        name: 'contact',
        component: () => import(/* webpackChunkName: "contact" */ './editViews/Contact.vue')
    },
    {
        path: '/contact-addresses',
        name: 'contactAddresses',
        component: () => import(/* webpackChunkName: "contact-addresses" */ './components/TableViewBase.vue'),
        staticProps: { tablePromise: () => import(/* webpackChunkName: "contact-addresses" */ './tables/ContactAddressesTable.vue'), pageTitle: 'Contact Addresses' }
    },
    {
        path: '/contact-emails',
        name: 'contactEmails',
        component: () => import(/* webpackChunkName: "contact-emails" */ './components/TableViewBase.vue'),
        staticProps: { tablePromise: () => import(/* webpackChunkName: "contact-emails" */ './tables/ContactEmailsTable.vue'), pageTitle: 'Contact Emails' }
    },
    {
        path: '/contact-phones',
        name: 'contactPhones',
        component: () => import(/* webpackChunkName: "contact-phones" */ './components/TableViewBase.vue'),
        staticProps: { tablePromise: () => import(/* webpackChunkName: "contact-phones" */ './tables/ContactPhonesTable.vue'), pageTitle: 'Contact Phones' }
    },
    {
        path: '/containers',
        name: 'containers',
        component: () => import(/* webpackChunkName: "containers" */ './components/TableViewBase.vue'),
        staticProps: { tablePromise: () => import(/* webpackChunkName: "containers" */ './tables/ContainersTable.vue'), pageTitle: 'Containers' }
    },
    {
        path: '/container-files',
        name: 'containerFiles',
        component: () => import(/* webpackChunkName: "container-files" */ './components/TableViewBase.vue'),
        staticProps: { tablePromise: () => import(/* webpackChunkName: "container-files" */ './tables/ContainerFilesTable.vue'), pageTitle: 'Container Files' }
    },
    {
        path: '/container-fills',
        name: 'containerFills',
        component: () => import(/* webpackChunkName: "container-fills" */ './components/TableViewBase.vue'),
        staticProps: { tablePromise: () => import(/* webpackChunkName: "container-fills" */ './tables/ContainerFillsTable.vue'), pageTitle: 'Container Fills' }
    },
    {
        path: '/container-tests',
        name: 'containerTests',
        component: () => import(/* webpackChunkName: "container-tests" */ './components/TableViewBase.vue'),
        staticProps: { tablePromise: () => import(/* webpackChunkName: "container-tests" */ './tables/ContainerTestsTable.vue'), pageTitle: 'Container Tests' }
    },
    {
        path: '/container-test-types',
        name: 'containerTestTypes',
        component: () => import(/* webpackChunkName: "container-test-types" */ './components/TableViewBase.vue'),
        staticProps: { tablePromise: () => import(/* webpackChunkName: "container-test-types" */ './tables/ContainerTestTypesTable.vue'), pageTitle: 'Container Test Types' }
    },
    {
        path: '/container-test-type/:id',
        name: 'containerTestType',
        component: () => import(/* webpackChunkName: "container-test-type" */ './editViews/ContainerTestType.vue')
    },
    {
        path: '/corrective-action-requests',
        name: 'correctiveActionRequests',
        component: () => import(/* webpackChunkName: "corrective-action-requests" */ './components/TableViewBase.vue'),
        staticProps: { tablePromise: () => import(/* webpackChunkName: "corrective-action-requests" */ './tables/CorrectiveActionRequestsTable.vue'), pageTitle: 'Corrective Action Requests' }
    },
    {
        path: '/countries',
        name: 'countries',
        component: () => import(/* webpackChunkName: "countries" */ './components/TableViewBase.vue'),
        staticProps: { tablePromise: () => import(/* webpackChunkName: "countries" */ './tables/CountriesTable.vue'), pageTitle: 'Countries' }
    },
    {
        path: '/country/:id',
        name: 'country',
        component: () => import(/* webpackChunkName: "country" */ './editViews/Country.vue')
    },
    {
        path: '/equipment-items',
        name: 'equipmentItems',
        component: () => import(/* webpackChunkName: "equipment-items" */ './components/TableViewBase.vue'),
        staticProps: { tablePromise: () => import(/* webpackChunkName: "equipment-items" */ './tables/EquipmentItemsTable.vue'), pageTitle: 'Equipment Items' }
    },
    {
        path: '/equipment-item/:id',
        name: 'equipmentItem',
        component: () => import(/* webpackChunkName: "equipment-item" */ './editViews/EquipmentItem.vue')
    },
    {
        path: '/equipment-item-files',
        name: 'equipmentItemFiles',
        component: () => import(/* webpackChunkName: "equipment-item-files" */ './components/TableViewBase.vue'),
        staticProps: { tablePromise: () => import(/* webpackChunkName: "equipment-item-files" */ './tables/EquipmentItemFilesTable.vue'), pageTitle: 'Equipment Item Files' }
    },
    {
        path: '/excel-imports',
        name: 'excelImports',
        component: () => import(/* webpackChunkName: "excel-imports" */ './components/TableViewBase.vue'),
        staticProps: { tablePromise: () => import(/* webpackChunkName: "excel-imports" */ './tables/ExcelImportsTable.vue'), pageTitle: 'Excel Imports' }
    },
    {
        path: '/excel-import/:id',
        name: 'excelImport',
        component: () => import(/* webpackChunkName: "excel-import" */ './editViews/ExcelImport.vue')
    },
    {
        path: '/excel-import-errors',
        name: 'excelImportErrors',
        component: () => import(/* webpackChunkName: "excel-import-errors" */ './components/TableViewBase.vue'),
        staticProps: { tablePromise: () => import(/* webpackChunkName: "excel-import-errors" */ './tables/ExcelImportErrorsTable.vue'), pageTitle: 'Excel Import Errors' }
    },
    {
        path: '/facilities',
        name: 'facilities',
        component: () => import(/* webpackChunkName: "facilities" */ './components/TableViewBase.vue'),
        staticProps: { tablePromise: () => import(/* webpackChunkName: "facilities" */ './tables/FacilitiesTable.vue'), pageTitle: 'Facilities' }
    },
    {
        path: '/facility/:id',
        name: 'facility',
        component: () => import(/* webpackChunkName: "facility" */ './editViews/Facility.vue')
    },
    {
        path: '/facility-files',
        name: 'facilityFiles',
        component: () => import(/* webpackChunkName: "facility-files" */ './components/TableViewBase.vue'),
        staticProps: { tablePromise: () => import(/* webpackChunkName: "facility-files" */ './tables/FacilityFilesTable.vue'), pageTitle: 'Facility Files' }
    },
    {
        path: '/facility-setups',
        name: 'facilitySetups',
        component: () => import(/* webpackChunkName: "facility-setups" */ './components/TableViewBase.vue'),
        staticProps: { tablePromise: () => import(/* webpackChunkName: "facility-setups" */ './tables/FacilitySetupsTable.vue'), pageTitle: 'Facility Setups' }
    },
    {
        path: '/feeds',
        name: 'feeds',
        component: () => import(/* webpackChunkName: "feeds" */ './components/TableViewBase.vue'),
        staticProps: { tablePromise: () => import(/* webpackChunkName: "feeds" */ './tables/FeedsTable.vue'), pageTitle: 'Feeds' }
    },
    {
        path: '/feed/:id',
        name: 'feed',
        component: () => import(/* webpackChunkName: "feed" */ './editViews/Feed.vue')
    },
    {
        path: '/feedings',
        name: 'feedings',
        component: () => import(/* webpackChunkName: "feedings" */ './components/TableViewBase.vue'),
        staticProps: { tablePromise: () => import(/* webpackChunkName: "feedings" */ './tables/FeedingsTable.vue'), pageTitle: 'Feedings' }
    },
    {
        path: '/feed-purchases',
        name: 'feedPurchases',
        component: () => import(/* webpackChunkName: "feed-purchases" */ './components/TableViewBase.vue'),
        staticProps: { tablePromise: () => import(/* webpackChunkName: "feed-purchases" */ './tables/FeedPurchasesTable.vue'), pageTitle: 'Feed Purchases' }
    },
    {
        path: '/feed-purchase/:id',
        name: 'feedPurchase',
        component: () => import(/* webpackChunkName: "feed-purchase" */ './editViews/FeedPurchase.vue')
    },
    {
        path: '/files',
        name: 'files',
        component: () => import(/* webpackChunkName: "files" */ './components/TableViewBase.vue'),
        staticProps: { tablePromise: () => import(/* webpackChunkName: "files" */ './tables/FilesTable.vue'), pageTitle: 'Files' }
    },
    {
        path: '/file/:id',
        name: 'file',
        component: () => import(/* webpackChunkName: "file" */ './editViews/File.vue')
    },
    {
        path: '/floral-varieties',
        name: 'floralVarieties',
        component: () => import(/* webpackChunkName: "floral-varieties" */ './components/TableViewBase.vue'),
        staticProps: { tablePromise: () => import(/* webpackChunkName: "floral-varieties" */ './tables/FloralVarietiesTable.vue'), pageTitle: 'Floral Varieties' }
    },
    {
        path: '/floral-variety/:id',
        name: 'floralVariety',
        component: () => import(/* webpackChunkName: "floral-variety" */ './editViews/FloralVariety.vue')
    },
    {
        path: '/floral-variety-nicknames',
        name: 'floralVarietyNicknames',
        component: () => import(/* webpackChunkName: "floral-variety-nicknames" */ './components/TableViewBase.vue'),
        staticProps: { tablePromise: () => import(/* webpackChunkName: "floral-variety-nicknames" */ './tables/FloralVarietyNicknamesTable.vue'), pageTitle: 'Floral Variety Nicknames' }
    },
    {
        path: '/formats',
        name: 'formats',
        component: () => import(/* webpackChunkName: "formats" */ './components/TableViewBase.vue'),
        staticProps: { tablePromise: () => import(/* webpackChunkName: "formats" */ './tables/FormatsTable.vue'), pageTitle: 'Formats' }
    },
    {
        path: '/format/:id',
        name: 'format',
        component: () => import(/* webpackChunkName: "format" */ './editViews/Format.vue')
    },
    {
        path: '/harvestings',
        name: 'harvestings',
        component: () => import(/* webpackChunkName: "harvestings" */ './components/TableViewBase.vue'),
        staticProps: { tablePromise: () => import(/* webpackChunkName: "harvestings" */ './tables/HarvestingsTable.vue'), pageTitle: 'Harvestings' }
    },
    {
        path: '/harvesting/:id',
        name: 'harvesting',
        component: () => import(/* webpackChunkName: "harvesting" */ './editViews/Harvesting.vue')
    },
    {
        path: '/harvesting-floral-varieties',
        name: 'harvestingFloralVarieties',
        component: () => import(/* webpackChunkName: "harvesting-floral-varieties" */ './components/TableViewBase.vue'),
        staticProps: { tablePromise: () => import(/* webpackChunkName: "harvesting-floral-varieties" */ './tables/HarvestingFloralVarietiesTable.vue'), pageTitle: 'Harvesting Floral Varieties' }
    },
    {
        path: '/hive-removals',
        name: 'hiveRemovals',
        component: () => import(/* webpackChunkName: "hive-removals" */ './components/TableViewBase.vue'),
        staticProps: { tablePromise: () => import(/* webpackChunkName: "hive-removals" */ './tables/HiveRemovalsTable.vue'), pageTitle: 'Hive Removals' }
    },
    {
        path: '/honey-types',
        name: 'honeyTypes',
        component: () => import(/* webpackChunkName: "honey-types" */ './components/TableViewBase.vue'),
        staticProps: { tablePromise: () => import(/* webpackChunkName: "honey-types" */ './tables/HoneyTypesTable.vue'), pageTitle: 'Honey Types' }
    },
    {
        path: '/honey-type/:id',
        name: 'honeyType',
        component: () => import(/* webpackChunkName: "honey-type" */ './editViews/HoneyType.vue')
    },
    {
        path: '/inspections',
        name: 'inspections',
        component: () => import(/* webpackChunkName: "inspections" */ './components/TableViewBase.vue'),
        staticProps: { tablePromise: () => import(/* webpackChunkName: "inspections" */ './tables/InspectionsTable.vue'), pageTitle: 'Inspections' }
    },
    {
        path: '/internal-corrective-action-requests',
        name: 'internalCorrectiveActionRequests',
        component: () => import(/* webpackChunkName: "internal-corrective-action-requests" */ './components/TableViewBase.vue'),
        staticProps: { tablePromise: () => import(/* webpackChunkName: "internal-corrective-action-requests" */ './tables/InternalCorrectiveActionRequestsTable.vue'), pageTitle: 'Internal Corrective Action Requests' }
    },
    {
        path: '/internal-member-audits',
        name: 'internalMemberAudits',
        component: () => import(/* webpackChunkName: "internal-member-audits" */ './components/TableViewBase.vue'),
        staticProps: { tablePromise: () => import(/* webpackChunkName: "internal-member-audits" */ './tables/InternalMemberAuditsTable.vue'), pageTitle: 'Internal Member Audits' }
    },
    {
        path: '/internal-member-audit/:id',
        name: 'internalMemberAudit',
        component: () => import(/* webpackChunkName: "internal-member-audit" */ './editViews/InternalMemberAudit.vue')
    },
    {
        path: '/labs',
        name: 'labs',
        component: () => import(/* webpackChunkName: "labs" */ './components/TableViewBase.vue'),
        staticProps: { tablePromise: () => import(/* webpackChunkName: "labs" */ './tables/LabsTable.vue'), pageTitle: 'Labs' }
    },
    {
        path: '/lab-client-organisations',
        name: 'labClientOrganisations',
        component: () => import(/* webpackChunkName: "lab-client-organisations" */ './components/TableViewBase.vue'),
        staticProps: { tablePromise: () => import(/* webpackChunkName: "lab-client-organisations" */ './tables/LabClientOrganisationsTable.vue'), pageTitle: 'Lab Client Organisations' }
    },
    {
        path: '/lab-client-organisation/:id',
        name: 'labClientOrganisation',
        component: () => import(/* webpackChunkName: "lab-client-organisation" */ './editViews/LabClientOrganisation.vue')
    },
    {
        path: '/lab-tests',
        name: 'labTests',
        component: () => import(/* webpackChunkName: "lab-tests" */ './components/TableViewBase.vue'),
        staticProps: { tablePromise: () => import(/* webpackChunkName: "lab-tests" */ './tables/LabTestsTable.vue'), pageTitle: 'Lab Tests' }
    },
    {
        path: '/lab-test/:id',
        name: 'labTest',
        component: () => import(/* webpackChunkName: "lab-test" */ './editViews/LabTest.vue')
    },
    {
        path: '/landowners',
        name: 'landowners',
        component: () => import(/* webpackChunkName: "landowners" */ './components/TableViewBase.vue'),
        staticProps: { tablePromise: () => import(/* webpackChunkName: "landowners" */ './tables/LandownersTable.vue'), pageTitle: 'Landowners' }
    },
    {
        path: '/landowner/:id',
        name: 'landowner',
        component: () => import(/* webpackChunkName: "landowner" */ './editViews/Landowner.vue')
    },
    {
        path: '/loads',
        name: 'loads',
        component: () => import(/* webpackChunkName: "loads" */ './components/TableViewBase.vue'),
        staticProps: { tablePromise: () => import(/* webpackChunkName: "loads" */ './tables/LoadsTable.vue'), pageTitle: 'Loads' }
    },
    {
        path: '/load-movements',
        name: 'loadMovements',
        component: () => import(/* webpackChunkName: "load-movements" */ './components/TableViewBase.vue'),
        staticProps: { tablePromise: () => import(/* webpackChunkName: "load-movements" */ './tables/LoadMovementsTable.vue'), pageTitle: 'Load Movements' }
    },
    {
        path: '/load-movement/:id',
        name: 'loadMovement',
        component: () => import(/* webpackChunkName: "load-movement" */ './editViews/LoadMovement.vue')
    },
    {
        path: '/members',
        name: 'members',
        component: () => import(/* webpackChunkName: "members" */ './components/TableViewBase.vue'),
        staticProps: { tablePromise: () => import(/* webpackChunkName: "members" */ './tables/MembersTable.vue'), pageTitle: 'Members' }
    },
    {
        path: '/member-certificates',
        name: 'memberCertificates',
        component: () => import(/* webpackChunkName: "member-certificates" */ './components/TableViewBase.vue'),
        staticProps: { tablePromise: () => import(/* webpackChunkName: "member-certificates" */ './tables/MemberCertificatesTable.vue'), pageTitle: 'Member Certificates' }
    },
    {
        path: '/member-files',
        name: 'memberFiles',
        component: () => import(/* webpackChunkName: "member-files" */ './components/TableViewBase.vue'),
        staticProps: { tablePromise: () => import(/* webpackChunkName: "member-files" */ './tables/MemberFilesTable.vue'), pageTitle: 'Member Files' }
    },
    {
        path: '/member-operations',
        name: 'memberOperations',
        component: () => import(/* webpackChunkName: "member-operations" */ './components/TableViewBase.vue'),
        staticProps: { tablePromise: () => import(/* webpackChunkName: "member-operations" */ './tables/MemberOperationsTable.vue'), pageTitle: 'Member Operations' }
    },
    {
        path: '/nucs',
        name: 'nucs',
        component: () => import(/* webpackChunkName: "nucs" */ './components/TableViewBase.vue'),
        staticProps: { tablePromise: () => import(/* webpackChunkName: "nucs" */ './tables/NucsTable.vue'), pageTitle: 'Nucs' }
    },
    {
        path: '/packer-containers',
        name: 'packerContainers',
        component: () => import(/* webpackChunkName: "packer-containers" */ './components/TableViewBase.vue'),
        staticProps: { tablePromise: () => import(/* webpackChunkName: "packer-containers" */ './tables/PackerContainersTable.vue'), pageTitle: 'Packer Containers' }
    },
    {
        path: '/packer-container/:id',
        name: 'packerContainer',
        component: () => import(/* webpackChunkName: "packer-container" */ './editViews/PackerContainer.vue')
    },
    {
        path: '/packer-container-files',
        name: 'packerContainerFiles',
        component: () => import(/* webpackChunkName: "packer-container-files" */ './components/TableViewBase.vue'),
        staticProps: { tablePromise: () => import(/* webpackChunkName: "packer-container-files" */ './tables/PackerContainerFilesTable.vue'), pageTitle: 'Packer Container Files' }
    },
    {
        path: '/pest-controls',
        name: 'pestControls',
        component: () => import(/* webpackChunkName: "pest-controls" */ './components/TableViewBase.vue'),
        staticProps: { tablePromise: () => import(/* webpackChunkName: "pest-controls" */ './tables/PestControlsTable.vue'), pageTitle: 'Pest Controls' }
    },
    {
        path: '/pest-control/:id',
        name: 'pestControl',
        component: () => import(/* webpackChunkName: "pest-control" */ './editViews/PestControl.vue')
    },
    {
        path: '/pest-control-files',
        name: 'pestControlFiles',
        component: () => import(/* webpackChunkName: "pest-control-files" */ './components/TableViewBase.vue'),
        staticProps: { tablePromise: () => import(/* webpackChunkName: "pest-control-files" */ './tables/PestControlFilesTable.vue'), pageTitle: 'Pest Control Files' }
    },
    {
        path: '/pollinations',
        name: 'pollinations',
        component: () => import(/* webpackChunkName: "pollinations" */ './components/TableViewBase.vue'),
        staticProps: { tablePromise: () => import(/* webpackChunkName: "pollinations" */ './tables/PollinationsTable.vue'), pageTitle: 'Pollinations' }
    },
    {
        path: '/products',
        name: 'products',
        component: () => import(/* webpackChunkName: "products" */ './components/TableViewBase.vue'),
        staticProps: { tablePromise: () => import(/* webpackChunkName: "products" */ './tables/ProductsTable.vue'), pageTitle: 'Products' }
    },
    {
        path: '/product/:id',
        name: 'product',
        component: () => import(/* webpackChunkName: "product" */ './editViews/Product.vue')
    },
    {
        path: '/product-dispatches',
        name: 'productDispatches',
        component: () => import(/* webpackChunkName: "product-dispatches" */ './components/TableViewBase.vue'),
        staticProps: { tablePromise: () => import(/* webpackChunkName: "product-dispatches" */ './tables/ProductDispatchesTable.vue'), pageTitle: 'Product Dispatches' }
    },
    {
        path: '/product-files',
        name: 'productFiles',
        component: () => import(/* webpackChunkName: "product-files" */ './components/TableViewBase.vue'),
        staticProps: { tablePromise: () => import(/* webpackChunkName: "product-files" */ './tables/ProductFilesTable.vue'), pageTitle: 'Product Files' }
    },
    {
        path: '/qualifications',
        name: 'qualifications',
        component: () => import(/* webpackChunkName: "qualifications" */ './components/TableViewBase.vue'),
        staticProps: { tablePromise: () => import(/* webpackChunkName: "qualifications" */ './tables/QualificationsTable.vue'), pageTitle: 'Qualifications' }
    },
    {
        path: '/queen-introductions',
        name: 'queenIntroductions',
        component: () => import(/* webpackChunkName: "queen-introductions" */ './components/TableViewBase.vue'),
        staticProps: { tablePromise: () => import(/* webpackChunkName: "queen-introductions" */ './tables/QueenIntroductionsTable.vue'), pageTitle: 'Queen Introductions' }
    },
    {
        path: '/queen-purchases',
        name: 'queenPurchases',
        component: () => import(/* webpackChunkName: "queen-purchases" */ './components/TableViewBase.vue'),
        staticProps: { tablePromise: () => import(/* webpackChunkName: "queen-purchases" */ './tables/QueenPurchasesTable.vue'), pageTitle: 'Queen Purchases' }
    },
    {
        path: '/queen-purchase/:id',
        name: 'queenPurchase',
        component: () => import(/* webpackChunkName: "queen-purchase" */ './editViews/QueenPurchase.vue')
    },
    {
        path: '/regions',
        name: 'regions',
        component: () => import(/* webpackChunkName: "regions" */ './components/TableViewBase.vue'),
        staticProps: { tablePromise: () => import(/* webpackChunkName: "regions" */ './tables/RegionsTable.vue'), pageTitle: 'Regions' }
    },
    {
        path: '/region-types',
        name: 'regionTypes',
        component: () => import(/* webpackChunkName: "region-types" */ './components/TableViewBase.vue'),
        staticProps: { tablePromise: () => import(/* webpackChunkName: "region-types" */ './tables/RegionTypesTable.vue'), pageTitle: 'Region Types' }
    },
    {
        path: '/region-type/:id',
        name: 'regionType',
        component: () => import(/* webpackChunkName: "region-type" */ './editViews/RegionType.vue')
    },
    {
        path: '/requests',
        name: 'requests',
        component: () => import(/* webpackChunkName: "requests" */ './components/TableViewBase.vue'),
        staticProps: { tablePromise: () => import(/* webpackChunkName: "requests" */ './tables/RequestsTable.vue'), pageTitle: 'Requests' }
    },
    {
        path: '/roles',
        name: 'roles',
        component: () => import(/* webpackChunkName: "roles" */ './components/TableViewBase.vue'),
        staticProps: { tablePromise: () => import(/* webpackChunkName: "roles" */ './tables/RolesTable.vue'), pageTitle: 'Roles' }
    },
    {
        path: '/role/:id',
        name: 'role',
        component: () => import(/* webpackChunkName: "role" */ './editViews/Role.vue')
    },
    {
        path: '/role-claims',
        name: 'roleClaims',
        component: () => import(/* webpackChunkName: "role-claims" */ './components/TableViewBase.vue'),
        staticProps: { tablePromise: () => import(/* webpackChunkName: "role-claims" */ './tables/RoleClaimsTable.vue'), pageTitle: 'Role Claims' }
    },
    {
        path: '/sales',
        name: 'sales',
        component: () => import(/* webpackChunkName: "sales" */ './components/TableViewBase.vue'),
        staticProps: { tablePromise: () => import(/* webpackChunkName: "sales" */ './tables/SalesTable.vue'), pageTitle: 'Sales' }
    },
    {
        path: '/sale/:id',
        name: 'sale',
        component: () => import(/* webpackChunkName: "sale" */ './editViews/Sale.vue')
    },
    {
        path: '/sale-containers',
        name: 'saleContainers',
        component: () => import(/* webpackChunkName: "sale-containers" */ './components/TableViewBase.vue'),
        staticProps: { tablePromise: () => import(/* webpackChunkName: "sale-containers" */ './tables/SaleContainersTable.vue'), pageTitle: 'Sale Containers' }
    },
    {
        path: '/sale-files',
        name: 'saleFiles',
        component: () => import(/* webpackChunkName: "sale-files" */ './components/TableViewBase.vue'),
        staticProps: { tablePromise: () => import(/* webpackChunkName: "sale-files" */ './tables/SaleFilesTable.vue'), pageTitle: 'Sale Files' }
    },
    {
        path: '/samples',
        name: 'samples',
        component: () => import(/* webpackChunkName: "samples" */ './components/TableViewBase.vue'),
        staticProps: { tablePromise: () => import(/* webpackChunkName: "samples" */ './tables/SamplesTable.vue'), pageTitle: 'Samples' }
    },
    {
        path: '/sample-sets',
        name: 'sampleSets',
        component: () => import(/* webpackChunkName: "sample-sets" */ './components/TableViewBase.vue'),
        staticProps: { tablePromise: () => import(/* webpackChunkName: "sample-sets" */ './tables/SampleSetsTable.vue'), pageTitle: 'Sample Sets' }
    },
    {
        path: '/sample-set/:id',
        name: 'sampleSet',
        component: () => import(/* webpackChunkName: "sample-set" */ './editViews/SampleSet.vue')
    },
    {
        path: '/sample-set-samples',
        name: 'sampleSetSamples',
        component: () => import(/* webpackChunkName: "sample-set-samples" */ './components/TableViewBase.vue'),
        staticProps: { tablePromise: () => import(/* webpackChunkName: "sample-set-samples" */ './tables/SampleSetSamplesTable.vue'), pageTitle: 'Sample Set Samples' }
    },
    {
        path: '/sample-set-tests',
        name: 'sampleSetTests',
        component: () => import(/* webpackChunkName: "sample-set-tests" */ './components/TableViewBase.vue'),
        staticProps: { tablePromise: () => import(/* webpackChunkName: "sample-set-tests" */ './tables/SampleSetTestsTable.vue'), pageTitle: 'Sample Set Tests' }
    },
    {
        path: '/sample-tests',
        name: 'sampleTests',
        component: () => import(/* webpackChunkName: "sample-tests" */ './components/TableViewBase.vue'),
        staticProps: { tablePromise: () => import(/* webpackChunkName: "sample-tests" */ './tables/SampleTestsTable.vue'), pageTitle: 'Sample Tests' }
    },
    {
        path: '/sample-test/:id',
        name: 'sampleTest',
        component: () => import(/* webpackChunkName: "sample-test" */ './editViews/SampleTest.vue')
    },
    {
        path: '/samplings',
        name: 'samplings',
        component: () => import(/* webpackChunkName: "samplings" */ './components/TableViewBase.vue'),
        staticProps: { tablePromise: () => import(/* webpackChunkName: "samplings" */ './tables/SamplingsTable.vue'), pageTitle: 'Samplings' }
    },
    {
        path: '/sites',
        name: 'sites',
        component: () => import(/* webpackChunkName: "sites" */ './components/TableViewBase.vue'),
        staticProps: { tablePromise: () => import(/* webpackChunkName: "sites" */ './tables/SitesTable.vue'), pageTitle: 'Sites' }
    },
    {
        path: '/site-floral-varieties',
        name: 'siteFloralVarieties',
        component: () => import(/* webpackChunkName: "site-floral-varieties" */ './components/TableViewBase.vue'),
        staticProps: { tablePromise: () => import(/* webpackChunkName: "site-floral-varieties" */ './tables/SiteFloralVarietiesTable.vue'), pageTitle: 'Site Floral Varieties' }
    },
    {
        path: '/site-treatments',
        name: 'siteTreatments',
        component: () => import(/* webpackChunkName: "site-treatments" */ './components/TableViewBase.vue'),
        staticProps: { tablePromise: () => import(/* webpackChunkName: "site-treatments" */ './tables/SiteTreatmentsTable.vue'), pageTitle: 'Site Treatments' }
    },
    {
        path: '/staff-members',
        name: 'staffMembers',
        component: () => import(/* webpackChunkName: "staff-members" */ './components/TableViewBase.vue'),
        staticProps: { tablePromise: () => import(/* webpackChunkName: "staff-members" */ './tables/StaffMembersTable.vue'), pageTitle: 'Staff Members' }
    },
    {
        path: '/staff-member/:id',
        name: 'staffMember',
        component: () => import(/* webpackChunkName: "staff-member" */ './editViews/StaffMember.vue')
    },
    {
        path: '/state-biosecurity-emails',
        name: 'stateBiosecurityEmails',
        component: () => import(/* webpackChunkName: "state-biosecurity-emails" */ './components/TableViewBase.vue'),
        staticProps: { tablePromise: () => import(/* webpackChunkName: "state-biosecurity-emails" */ './tables/StateBiosecurityEmailsTable.vue'), pageTitle: 'State Biosecurity Emails' }
    },
    {
        path: '/temperature-checks',
        name: 'temperatureChecks',
        component: () => import(/* webpackChunkName: "temperature-checks" */ './components/TableViewBase.vue'),
        staticProps: { tablePromise: () => import(/* webpackChunkName: "temperature-checks" */ './tables/TemperatureChecksTable.vue'), pageTitle: 'Temperature Checks' }
    },
    {
        path: '/temperature-check/:id',
        name: 'temperatureCheck',
        component: () => import(/* webpackChunkName: "temperature-check" */ './editViews/TemperatureCheck.vue')
    },
    {
        path: '/temperature-check-files',
        name: 'temperatureCheckFiles',
        component: () => import(/* webpackChunkName: "temperature-check-files" */ './components/TableViewBase.vue'),
        staticProps: { tablePromise: () => import(/* webpackChunkName: "temperature-check-files" */ './tables/TemperatureCheckFilesTable.vue'), pageTitle: 'Temperature Check Files' }
    },
    {
        path: '/tests',
        name: 'tests',
        component: () => import(/* webpackChunkName: "tests" */ './components/TableViewBase.vue'),
        staticProps: { tablePromise: () => import(/* webpackChunkName: "tests" */ './tables/TestsTable.vue'), pageTitle: 'Tests' }
    },
    {
        path: '/test/:id',
        name: 'test',
        component: () => import(/* webpackChunkName: "test" */ './editViews/Test.vue')
    },
    {
        path: '/test-groups',
        name: 'testGroups',
        component: () => import(/* webpackChunkName: "test-groups" */ './components/TableViewBase.vue'),
        staticProps: { tablePromise: () => import(/* webpackChunkName: "test-groups" */ './tables/TestGroupsTable.vue'), pageTitle: 'Test Groups' }
    },
    {
        path: '/test-group/:id',
        name: 'testGroup',
        component: () => import(/* webpackChunkName: "test-group" */ './editViews/TestGroup.vue')
    },
    {
        path: '/test-results',
        name: 'testResults',
        component: () => import(/* webpackChunkName: "test-results" */ './components/TableViewBase.vue'),
        staticProps: { tablePromise: () => import(/* webpackChunkName: "test-results" */ './tables/TestResultsTable.vue'), pageTitle: 'Test Results' }
    },
    {
        path: '/treatments',
        name: 'treatments',
        component: () => import(/* webpackChunkName: "treatments" */ './components/TableViewBase.vue'),
        staticProps: { tablePromise: () => import(/* webpackChunkName: "treatments" */ './tables/TreatmentsTable.vue'), pageTitle: 'Treatments' }
    },
    {
        path: '/units',
        name: 'units',
        component: () => import(/* webpackChunkName: "units" */ './components/TableViewBase.vue'),
        staticProps: { tablePromise: () => import(/* webpackChunkName: "units" */ './tables/UnitsTable.vue'), pageTitle: 'Units' }
    },
    {
        path: '/unit/:id',
        name: 'unit',
        component: () => import(/* webpackChunkName: "unit" */ './editViews/Unit.vue')
    },
    {
        path: '/users',
        name: 'users',
        component: () => import(/* webpackChunkName: "users" */ './components/TableViewBase.vue'),
        staticProps: { tablePromise: () => import(/* webpackChunkName: "users" */ './tables/UsersTable.vue'), pageTitle: 'Users' }
    },
    {
        path: '/user-roles',
        name: 'userRoles',
        component: () => import(/* webpackChunkName: "user-roles" */ './components/TableViewBase.vue'),
        staticProps: { tablePromise: () => import(/* webpackChunkName: "user-roles" */ './tables/UserRolesTable.vue'), pageTitle: 'User Roles' }
    },
]
